export default "__VITE_ASSET__BczCg0Ig__"